
export class UserNotification {

  constructor(
    public hash?: string,
    public manufacturingOrderNotificationHash?: string,
    public manufacturingOrderNotificationManufacturingOrderCode?: string,
    public manufacturingOrderNotificationManufacturingOrderHash?: string,
    public userHash?: string,
    public userName?: string,
    public receiverHash?: string,
    public receiverName?: string,
    public comment?: string,
    public date?: number,
    public isRead?: boolean,
    public isQuantityChanged?: boolean,
    public isManufacturingOrderDeliveryDateChanged?: boolean,
    public message?: string,
    public title?: string,
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user-notification.ts